import React, { useEffect, useState } from "react";
import Image from "next/image";
import CloseIcon from "@/components/_icons/closeIcon";
import { ImageModalCloseButton } from "@/components/_icons/imageModalCloseButton";
import { addToServiceCart, getServiceCartItems } from "./serviceSummary";
import { lightenColor } from "@/utils/lightenColor";

export const ServiceModalEmployeeSelection = ({
  onRequestClose,
  productImage,
  service,
  employeeList,
  handleEmployeeSelect,
  selectedEmployee,
  setShowEmployeeSelection,
  handleAddToServiceCart,
  finalPrice,
  merchantPreferences,
  merchantColor,
}: any) => {
  const [serviceCartCount, setServiceCartCount] = useState(0);

  useEffect(() => {
    const cartItems = getServiceCartItems();
    setServiceCartCount(cartItems.length);
  }, []);

  const radioColor: React.CSSProperties = {
    "--checked-bg-color": merchantColor,
    "--checked-border-color": merchantColor,
  } as React.CSSProperties;

  return (
    <div className="relative bg-white sm:rounded-lg shadow-lg w-full sm:max-w-[900px] flex flex-col sm:flex-row-reverse sm:w-auto mx-auto h-[100%] sm:max-h-[576px] overflow-y-auto sm:overflow-x-visible">
      <button
        onClick={onRequestClose}
        className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 z-10"
      >
        {productImage ? <ImageModalCloseButton /> : <CloseIcon />}
      </button>
      {productImage && (
        <div className="flex-shrink-0 sm:w-[50%] sm:max-h-full">
          <Image
            width={450}
            height={576}
            alt={service.name || "service name"}
            src={productImage.source}
            className="object-cover object-center w-auto h-full"
          />
        </div>
      )}
      <div
        className={`flex flex-col sm:min-h-[260px] w-full ${
          productImage ? "sm:w-[50%]" : "sm:w-[530px] pb-[64px]"
        } relative h-auto`}
      >
        <div className="px-6 pt-6">
          <h2 className="pt-4 text-4xl text-[32px] font-medium text-[#373737] whitespace-nowrap overflow-hidden text-ellipsis">
            Select professional
          </h2>
        </div>
        <div className="py-4 px-6 overflow-y-auto">
          <p className="text-[15px]  text-[#727272] font-semibold">STAFF</p>
          <div className="my-4 pr-4 max-h-[400px] sm:max-h-[350px]">
            {employeeList.map((employee: any) => (
              <div
                key={employee.employeeUuid}
                className="flex items-center mb-4 border-b border-[#E5E5E5] pb-4"
                onClick={() => handleEmployeeSelect(employee.employeeUuid)}
                style={radioColor}
              >
                <input
                  type="radio"
                  name="employee"
                  value={employee.employeeUuid}
                  checked={selectedEmployee === employee.employeeUuid}
                  onChange={() => handleEmployeeSelect(employee.employeeUuid)}
                  className="mr-3 appearance-none w-[22px] h-[22px] border border-gray-400 rounded-full checked:bg-[var(--checked-bg-color)] checked:border-[var(--checked-border-color)] flex items-center justify-center checked:after:content-[''] checked:after:bg-white checked:after:w-[10px] checked:after:h-[10px] checked:after:rounded-full"
                />
                <div className="w-10 h-10 bg-[#C4C4C4] rounded-full flex items-center justify-center mr-4 font-light text-[20px]">
                  {employee.name[0]}
                </div>
                <div className="flex-1">
                  <p className="font-normal text-[15px]">
                    {employee.nickName ? employee.nickName : employee.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="fixed sm:absolute bottom-0 left-0 w-full h-[64px] flex">
          <button
            style={{
              backgroundColor: lightenColor(merchantColor, 90),
            }}
            className="w-2/5 h-full bg-[#E5E5E5] text-gray-900 text-xl font-medium flex items-center justify-center"
            onClick={() => setShowEmployeeSelection(false)}
          >
            Back
          </button>
          <button
            style={{
              backgroundColor: merchantColor,
            }}
            className="w-3/5 h-full bg-[#2E2E2E] text-white text-xl font-medium flex flex-row items-center justify-between px-4 disabled:bg-[#E5E5E5]"
            onClick={() => {
              handleAddToServiceCart();
            }}
          >
            <p>Book</p>
            <p> ${(finalPrice / 100).toFixed(2)}</p>
          </button>
        </div>
      </div>
    </div>
  );
};
